import React from 'react'

type AnchorProps = JSX.IntrinsicElements['a']

interface Props extends Omit<AnchorProps, 'href'> {
    to: AnchorProps['href']
}

const ExternalLink = React.forwardRef<HTMLAnchorElement, Props>(
    ({children, to, target = '_blank', ...props}, ref) => (
        <a
            ref={ref}
            {...props}
            href={to}
            target={target}
            rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        >
            {children}
        </a>
    ),
)

export default ExternalLink
